import { Box } from "@mui/material";
import { ReactComponent as Checkbox } from "assets/Checkbox.svg";
import DeleteCircle from "assets/DeleteCircle";
import { ReactComponent as DeleteIcon } from "assets/DeleteIcon.svg";
import { ReactComponent as Radio } from "assets/Radio.svg";
import { ReactComponent as AddCircle } from "assets/add-circle-small.svg";
import Input from "components/common/Input";
import ButtonLink from "components/common/Link";
import { setFeedbackDetails } from "components/common/Snackbar/snackbar.slice";
import Typography from "components/common/Typography";
import DropDown from "components/common/dropdowns/DropDown";
import { useState } from "react";
import { useFormContext } from "react-hook-form";
import { useDispatch } from "react-redux";
import { useAppSelector } from "redux/hooks";
import { tokens } from "styles/Tokens";
import { converter_ArrayObj } from "utils/CommonFunctions";
import "./index.scss";

export const questionTypes = {
  "Radio button": { placeholder: "Sample text" },
  Rating: { placeholder: "Rate your experience." },
  Checkbox: { placeholder: "Sample text" },
  "Open question": { placeholder: "Sample text" }
};

export default function Question(props) {
  const dispatch = useDispatch();
  const { questionIndex, category, categoryId, onDelete, question, answers, isNew } = props;
  const {
    register,
    watch,
    getValues,
    setValue,
    formState: {
      errors: { questions: questionsFormErrors }
    }
  } = useFormContext();

  const namePrefix = `questions.[${questionIndex}].`;
  const chooseComponents = watch(`${namePrefix}category`) || category;

  const questionCategories = useAppSelector((state) => state.feedback.questionCategories.list);

  const [input, setInput] = useState(answers || []);

  const addDynamicInput = () => {
    if ((chooseComponents === "Radio Button" || chooseComponents === "Checkbox") && input.length > 5) {
      dispatch(
        setFeedbackDetails({
          shouldShow: true,
          variant: "error",
          setState: setFeedbackDetails({ shouldShow: false }),
          message: "Only 6 options can be added."
        })
      );
    } else setInput([...input, { id: `NEW_${Date.now()}`, isNew: true }]);
  };

  const handleInputChange = (answer, value) => {
    setInput(input.map((item) => (item.id === answer.id ? { ...answer, option: value } : item)));
  };

  const deleteDynamicInput = (index) => {
    const newInputs = input.filter((item) => item.id !== index); // Remove the input at the specified index
    setInput(newInputs);
    setValue(`${namePrefix}answers`, newInputs);
  };

  const getDynamicRadiosAndCheckboxes = () => {
    return (
      <>
        <div>
          {input?.map((answer, index) => (
            <Box width={"80%"} key={index} display={"flex"} flexDirection={"row"} alignItems={"center"} gap={"4px"}>
              <div>{chooseComponents === "Radio Button" ? <Radio /> : <Checkbox />}</div>

              <input value={answer.id} type="hidden" {...register(`${namePrefix}answers.[${index}].id`)} />
              <input value={answer.order} type="hidden" {...register(`${namePrefix}answers.[${index}].order`)} />
              <input value={answer.isNew} type="hidden" {...register(`${namePrefix}answers.[${index}].isNew`)} />

              <Input
                label=""
                name={`${namePrefix}answers.[${index}].option`}
                register={register}
                validations={{ required: true }}
                error={questionsFormErrors?.[questionIndex]?.answers?.[index]?.option}
                handleChangeUpdate={(value) => handleInputChange(answer, value)}
                textVariant="body2"
                placeholder={`Option ${index + 1}`}
                maxLength={80}
                color={tokens.Text.General.PrimaryHeadline}
                value={getValues(`${namePrefix}answers.[${answer.id}].option`) || input[index].option}
              />

              <Box sx={{ cursor: "pointer", marginLeft: "4px" }} onClick={() => deleteDynamicInput(answer.id)}>
                <DeleteIcon />
              </Box>
            </Box>
          ))}
        </div>
        {/* {(chooseComponents === "Radio Button" ? input.length < 2 : true) && ( */}
        <Box display={"flex"} flexDirection={"row"} alignItems={"center"} gap={"8px"} paddingLeft={"20px"}>
          <AddCircle />
          <ButtonLink
            text={
              <Typography variant={"label"} showBold>
                Add Option
              </Typography>
            }
            textVariant="body2"
            underline="none"
            sx={{ color: tokens.Text.General.Color }}
            onClick={() => addDynamicInput(chooseComponents)}
          />
        </Box>
        {/* )} */}
      </>
    );
  };

  const getQuestionComponents = () => {
    switch (chooseComponents) {
      case "Radio Button":
      case "Checkbox":
        return getDynamicRadiosAndCheckboxes();

      default:
        <></>;
    }
  };

  const handleChange = (value) => {
    const item = questionCategories?.find((el) => el.id === value || el.category === value);
    setValue(`${namePrefix}categoryId`, item?.id);
    setValue(`${namePrefix}category`, item?.category);
  };

  return (
    <div className="question">
      <div className="question_delete-row">
        <Typography variant={"h5"} showBold color={tokens.Text.General.PrimaryHeadline}>
          Question {questionIndex + 1}
        </Typography>
        <div onClick={() => onDelete(questionIndex)} style={{ cursor: "pointer" }}>
          <DeleteCircle color={tokens.Icon.Feeback.Alert} />
        </div>
      </div>
      <DropDown
        disabled={!!category && !isNew}
        label="Choose component"
        name={`${namePrefix}category`}
        register={register}
        error={questionsFormErrors?.[questionIndex]?.category}
        initialValue={!isNew ? category : getValues(`${namePrefix}category`) || "Rating"}
        validations={{ required: isNew }}
        options={converter_ArrayObj(questionCategories, "category")}
        handleChangeUpdate={handleChange}
        sx={{ width: "280px" }}
      />

      <input type="hidden" {...register(`${namePrefix}categoryId`)} />

      <Input
        label="Question"
        name={`${namePrefix}question`}
        register={register}
        error={questionsFormErrors?.[questionIndex]?.question}
        validations={{ required: true }}
        textVariant="body2"
        maxLength={80}
        value={question}
        placeholder={"Sample Text"}
        sx={{ width: "100%" }}
        color={tokens.Text.General.PrimaryHeadline}
      />
      {getQuestionComponents()}
    </div>
  );
}
